import { Box, ButtonBase, Icon, Snackbar } from "@mui/material";
import { SB } from "./tokens";
import type { PendingDelete } from "./useUndoableDelete";

type UndoToastProps = {
  pending: PendingDelete | null;
  onUndo: () => void;
  onDismiss: () => void;
};

/** The "Deleted …  Undo" toast. Stays until the undo window closes. */
export function UndoToast({ pending, onUndo, onDismiss }: UndoToastProps) {
  return (
    <Snackbar
      open={!!pending}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ bottom: { xs: 48 } }}
    >
      <Box
        role="status"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          pl: 1.75,
          pr: 0.75,
          py: 0.75,
          borderRadius: "10px",
          background: SB.menu,
          boxShadow:
            "inset 0 0 0 1px rgba(255,255,255,0.09), 0 16px 40px -10px rgba(0,0,0,0.7)",
          color: SB.textRow,
          fontSize: 13,
          whiteSpace: "nowrap",
        }}
      >
        <span>{pending?.text}</span>
        <ButtonBase
          onClick={onUndo}
          sx={{
            height: 28,
            px: 1.25,
            borderRadius: "6px",
            fontSize: 12.5,
            fontWeight: 600,
            color: SB.accent,
            "&:hover": { background: "rgba(0,212,172,0.12)" },
            "&:focus-visible": { outline: `2px solid ${SB.accent}`, outlineOffset: 1 },
          }}
        >
          Undo
        </ButtonBase>
        <ButtonBase
          aria-label="Dismiss"
          onClick={onDismiss}
          sx={{
            width: 28,
            height: 28,
            borderRadius: "6px",
            color: SB.textIcon,
            "&:hover": { background: "rgba(255,255,255,0.08)", color: SB.text },
          }}
        >
          <Icon sx={{ fontSize: 16 }}>close</Icon>
        </ButtonBase>
      </Box>
    </Snackbar>
  );
}
